
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ModelSection } from './components/ModelSection';
import { TechSection } from './components/TechSection';
import { CTASection } from './components/CTASection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <HowItWorksSection />
        <BenefitsSection />
        <ModelSection />
        <TechSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
